<template>
    <div class="header-container">
        <img id="appLogo" alt="绿洲智能医生" src="../assets/images/logo.png" width="284px" @click="doGoHome">
        <div class="nav-container">
            <router-link :to="{name: 'Home'}">首页</router-link>
            <!-- <router-link :to="{name: 'AppointmentSearchDoctor'}" style="margin-left: 80px">挂号</router-link> -->
            <router-link :to="{name: 'Download'}" style="margin-left: 80px">下载</router-link>
            <!-- <label v-if="!isLogined" style="margin-left: 88px">
              <span @click="isShowLoginDialog = true">登录</span>
            </label>
            <label v-else style="margin-left: 88px">
              <el-popover
                placement="bottom"
                title=""
                width="150"
                trigger="hover">
                <el-button style="width: 100%" type="danger" size="small" @click="doLogout">退出登录</el-button>
                <label  slot="reference" style="font-size: 18px">{{userInfo.loginName}}</label>
              </el-popover>
            </label> -->
        </div>

        <el-dialog title="" :visible.sync="isShowLoginDialog"
                   width="600px"
                   :close-on-click-modal="false"
                   @open="doDialogOpened"
                   @close="doDialogClosed"
                   :show-close="false">
            <div slot="title"></div>
            <div>
                <span class="dialog-close-btn" @click="doCloseLoginBtn">
                    <i class="el-icon-close"></i>
                </span>

                <div class="dialog-content">
                    <div style="font-size:20px;font-weight:bold;color:rgba(51,51,51,1); margin-left: 60px; margin-bottom: 24px; margin-top: 6px">登录</div>
                    <div style="margin-right: 100px; margin-left: 60px">
                        <el-form :model="loginForm" :rules="rules" ref="loginForm">
                            <el-form-item label="" prop="phone">
                                <el-input ref="phoneRef"  v-model="loginForm.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                            <el-form-item label="" prop="code">
                                <el-input ref="codeRef" placeholder="验证码" maxlength="6" v-model="loginForm.code">
                                    <el-button slot="append"
                                               :disabled="getCode.timerCount > 0"
                                               :loading="getCode.isGettingCode"
                                               @click="doGetLoginCode">
                                        <span v-if="getCode.timerCount <= 0">获取验证码</span>
                                        <span v-else>{{remainSeconds}}秒</span>
                                    </el-button>
                                </el-input>
                            </el-form-item>
                        </el-form>

                        <div style="font-size:18px;font-weight:400;color:rgba(255,171,72,1);">
                            <el-checkbox v-model="loginForm.isAcceptRules">本人已认真阅读并同意</el-checkbox>
                            <a target="_blank" href="/static/service_protocol.html">《软件服务协议》</a>
                            <a target="_blank" href="/static/private_policy.html">《隐私条款》</a>

                        </div>
                        <div style="margin-top: 16px; margin-bottom: 16px">
                            <el-button style="width:440px;height:52px;"
                                       type="primary"
                                       :loading="loginForm.isSubmitting"
                                       :disabled="loginForm.isSubmitting"
                                       @click="doLogin">
                                <span style="font-size:18px;font-weight:400;color:rgba(255,255,255,1);">
                                    <span v-if="loginForm.isSubmitting">登录中...</span>
                                    <span v-else>登录/注册</span>
                                </span>
                            </el-button>
                        </div>
                        <div style="font-size:14px;font-weight:400;color:rgba(102,102,102,1); text-align: center; margin-bottom: 20px">
                            未注册过的手机号登录后将自动创建账号
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {REG_PHONE_NO} from '../lib/regExpUtil'
import { UserInfo } from '../lib/AppConstant'
import Cookies from 'js-cookie'
import * as DateFns from 'date-fns'
import * as _ from 'lodash'
const KeyLastGetCodeTime = 'KeyLastGetCodeTime'
const MaxGetCodeCount = 60
export default {
  name: 'AppHeader',
  data () {
    return {
      isShowLoginDialog: false,
      loginForm: {
        phone: '',
        code: '',
        isAcceptRules: false,
        isSubmitting: false
      },
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' },
          { pattern: REG_PHONE_NO, message: '请输入以1开始的11位手机号' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 1, max: 6, message: '验证码长度在6个字符', trigger: 'blur' }]
      },
      getCode: {
        getCodeTimer: null, // timer ID
        isGettingCode: false,
        lastGetCodeTime: 0, // 最后获取验证码时间戳
        timerCount: 0 // 下一次获取验证码剩余时间
      },
      userInfo: {
        certificationMobile: '',
        roleId: null,
        careFirstOrderMedia: null,
        vinuxId: '',
        avatar: '',
        roleType: null,
        userName: '',
        userId: null,
        loginName: '',
        nickname: '',
        roleName: '',
        firstOrder: null,
        userType: null,
        sellerType: null,
        token: ''
      }
    }
  },
  computed: {
    isLogined: function () {
      return this.$store.getters.isLogined
    },
    remainSeconds () {
      return MaxGetCodeCount - this.getCode.timerCount
    }
  },
  created () {
  },
  mounted () {
    const userInfoStr = Cookies.get(UserInfo)
    if (userInfoStr != null && userInfoStr.length > 0) {
      const userInfo = JSON.parse(userInfoStr)
      this.userInfo = userInfo
    }
    this.checkLastGetCodeTime()
  },
  destroyed () {
    if (this.getCode.getCodeTimer != null) {
      clearInterval(this.getCode.getCodeTimer)
      this.getCode.getCodeTimer = null
    }
  },
  methods: {
    getLastGetCodeInterval () {
      const aBigInt = 10000000
      const lastGetCodeTime = Cookies.get(KeyLastGetCodeTime)
      if (lastGetCodeTime == null) {
        return aBigInt
      }
      const lastDate = new Date(parseInt(lastGetCodeTime))
      if (lastDate == null || lastDate === undefined) {
        return aBigInt
      }
      const current = new Date()
      const interval = DateFns.differenceInSeconds(current, lastDate)
      return interval
    },
    checkLastGetCodeTime () {
      const interval = this.getLastGetCodeInterval()
      console.log('上次获取验证码到现在相差' + interval + '秒')
      if (interval < MaxGetCodeCount) {
        this.startGetCodeTimer(interval)
      }
    },
    doDialogOpened () {
      this.loginForm.phone = ''
      this.loginForm.code = ''
      this.loginForm.isAcceptRules = false
      if (this.$refs.loginForm !== undefined) {
        this.$refs.loginForm.clearValidate()
      }
      this.isShowLoginDialog = true
    },
    doDialogClosed () {
      this.loginForm.phone = ''
      this.loginForm.code = ''
      this.loginForm.isAcceptRules = false
      if (this.$refs.loginForm !== undefined) {
        this.$refs.loginForm.clearValidate()
      }
    },
    doCloseLoginBtn () {
      this.isShowLoginDialog = false
    },
    doGetLoginCode () {
      if (this.loginForm.isAcceptRules === false) {
        this.$message.error('认真阅读并同意《绿洲智能医生软件服务协议》《绿洲智能医生隐私条款》')
        return
      }

      this.loginForm.code = ''
      this.$refs.loginForm.clearValidate(['code'])
      this.$refs.loginForm.validateField(['phone'], (message) => {
        if (message == null || message === undefined || message.length > 0) {
          return false
        }

        const param = {
          phone: this.loginForm.phone.trim() + '',
          from: 'p'
        }
        this.getCode.isGettingCode = true
        // eslint-disable-next-line no-unused-vars
        this.$post('doctor/login/sendLoginValidatCode', param).then(value => {
          this.$message.success('获取验证码成功,请注意查收')
          this.startGetCodeTimer(0)
        }).finally(() => {
          this.getCode.isGettingCode = false
        })
        // end
      })
    },
    startGetCodeTimer (remainCount) {
      if (this.getCode.getCodeTimer != null) {
        clearInterval(this.getCode.getCodeTimer)
      }
      this.getCode.timerCount = remainCount
      if (remainCount <= 0) {
        Cookies.set(KeyLastGetCodeTime, new Date().getTime())
      }
      this.getCode.timerCount = this.getCode.timerCount + 1
      this.getCode.getCodeTimer = setInterval(() => {
        // console.log('------Timer-------' + this.getCode.timerCount)
        this.getCode.timerCount = this.getCode.timerCount + 1
        if (this.getCode.timerCount >= MaxGetCodeCount) {
          clearInterval(this.getCode.getCodeTimer)
          this.getCode.timerCount = 0
        }
      }, 1000)
    },
    doLogin () {
      if (this.loginForm.isAcceptRules === false) {
        this.$message.error('认真阅读并同意《绿洲智能医生软件服务协议》《绿洲智能医生隐私条款》')
        return false
      }
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请填写完整信息')
          return false
        }

        const param = {
          phone: this.loginForm.phone + '',
          from: 'p',
          smsValidateCode: this.loginForm.code + ''
        }
        this.loginForm.isSubmitting = true
        this.$post('doctor/login/loginByValidatCode', param).then(value => {
          this.doCloseLoginBtn()
          this.$message.success('登录成功!')
          this.parseLoginInfo(value)
        }).catch(() => {
          this.loginForm.isSubmitting = false
        })
        // end
      })
    },
    parseLoginInfo (resp) {
      if (_.has(resp, 'userInfo') === false ||
                    _.has(resp, 'access_string') === false) {
        this.$message.error('解析登录数据失败')
        return false
      }
      let userInfo = _.get(resp, 'userInfo')
      Object.assign(this.userInfo, userInfo)
      this.userInfo.token = resp.access_string + ''

      Cookies.set(UserInfo, JSON.stringify(this.userInfo))
      this.$store.dispatch('setUserInfo', this.userInfo)

      this.loginForm.phone = ''
      this.loginForm.code = ''
      Cookies.remove(KeyLastGetCodeTime)
    },
    doLogout () {
      this.$confirm('确定退出当前账号吗 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$get('doctor/login/logout').then(value => {
          Cookies.remove(UserInfo)
          this.$message.success('退出成功')
          this.$store.dispatch('doLogout', {})
          window.location.reload()
        }).finally(() => {})
      }).catch(() => {})
      // end
    },
    doGoHome () {
      this.$router.push({name: 'Home'})
    }
  }
}
</script>

<style scoped>
    .header-container {
        height:100px;
        line-height: 100px;
        background:rgba(255,255,255,1);
        /*background-color: #8c939d;*/
        margin: 0 auto;
        position: relative;
        /*min-width: 992px;*/
    }

    .header-container #appLogo {
        position: absolute;
        top: 20px;
        left: 0px;
    }

    @media only screen and (min-width: 992px) {
        .header-container {
            width: 992px;
        }
    }

    @media only screen and (min-width: 1200px) {
        .header-container {
            width: 1200px;
        }
    }

    .nav-container {
        position: absolute;
        top: 0px;
        bottom: 0px;
        right: 0px;
    }

    .nav-container a {
        color: black;
        font-size:18px;
        font-weight:400;
        color:rgba(51,51,51,1);
    }

    .nav-container span {
      color: black;
      font-size:18px;
      font-weight:400;
      color:rgba(51,51,51,1);
    }

    .nav-container a:hover {
        color: #32C972;
    }
    .nav-container a:active {
        color: #32C972;
    }

    .nav-container span:hover {
      color: #32C972;
    }
    .nav-container span:active {
      color: #32C972;
    }

    .user-info {
        position: absolute;
        top: 0px;
        bottom: 0px;
        right: 0px;
        text-align: right;
    }

    .user-info label {
        padding: 6px;
        font-size:18px;
        font-weight:400;
        color:rgba(51,51,51,1);
        /*background-color: #8c939d;*/
    }
    .user-info label:active {
        color: #32C972;
    }
    .user-info label:hover {
        color: #32C972;
    }

    /*  ********************Dialog**********************  */
    .dialog-close-btn {
        position: absolute;
        right: -15px;
        top: -15px;
        background-color: white;
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: rgba(159, 159, 159, 1);
        border: 2px solid rgba(255, 255, 255, 1);
        border-radius: 50%;
    }
    .dialog-close-btn i {
        color: white;
        font-weight: bold;
        font-size: 16px;
        margin-top: 8px;
    }
    .dialog-close-btn i:hover {
        color: lightgray;
    }
    .dialog-close-btn:active {
        background-color: lightgray;
        color: black;
    }
    .dialog-content {
        min-height: 100px;
        margin-top: -30px;
        margin-bottom: -4px;
        /*border: 1px solid #e4e4e4;*/
        padding-top: -20px;
        line-height: normal;

        width: 600px;
        padding-right: 100px;
        padding-right: 100px;
    }

</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue